import { clsx } from 'clsx';
import React from 'react';

export const PersonaFormBlock = ({ label, children, compact, fields }) => {
  return Boolean(fields.filter(Boolean).length) ? (
    <div className={clsx('flex gap-2.5', compact ? 'flex-col' : 'flex-row')}>
      <div className={clsx('text-[#7A6BE5] font-bold text-sm', !compact && 'min-w-[100px]')}>
        <p>{label}</p>
      </div>
      <div
        className={clsx('flex flex-row w-full gap-2.5', compact ? 'items-center' : 'items-start')}
      >
        {children}
      </div>
    </div>
  ) : null;
};
